import axios, { AxiosError, AxiosHeaders, AxiosRequestConfig, AxiosResponse, AxiosResponseTransformer, HeadersDefaults, HttpStatusCode, InternalAxiosRequestConfig, RawAxiosRequestHeaders } from "axios";
import Cookies from "js-cookie";
import { ILoginResponseData, IResponse } from "../Interfaces/ResponsesData";
import { ILoginData } from "../Interfaces/RequestsData";
import { Globals } from "../Globals/GlobalObs";



export class AxiosRequest{

    private static baseUrl = 'https://crmbe.focusmarketing.tech/api/'

    //https://crmbe.focusmarketing.tech/api/
    //'http://127.0.0.1:8000/api/'
    //'https://7savip.com/BEproject-x/api/'

    private static getInstance(token:string,device_key:string,transform?:AxiosResponseTransformer | AxiosResponseTransformer[] | undefined  ){
      const instance = axios.create({
          baseURL:AxiosRequest.baseUrl,
          transformResponse:transform,
          headers:{'Authorization' : `Bearer ${token}` , 'x-device-key': device_key}
      });
      return instance;
    }
    public static async postClear<Response>(url:string, transform?:AxiosResponseTransformer | AxiosResponseTransformer[] | undefined ){
      const token = await Globals.auth.getToken()
      const device_key = Cookies.get('dev_tkn')
      if(device_key){
        if(token){
          const instance = await AxiosRequest.getInstance(token,device_key,transform).post<IResponse<Response>>(url)
          if(instance.data.messege == 'A0006') Globals.auth.deviceFailure()
          else return instance
        }else{
          Globals.auth.authFailure()
        }
      }else Globals.auth.deviceFailure()

    }
    public static async postStatusClear(url:string, transform?:AxiosResponseTransformer | AxiosResponseTransformer[] | undefined ){
      const token = await Globals.auth.getToken()
      const device_key = Cookies.get('dev_tkn')
      if(device_key){
        if(token){
          const instance = await AxiosRequest.getInstance(token,device_key,transform).post<IResponse<null>>(url)
          if(instance.data.messege == 'A0006') Globals.auth.deviceFailure()
            else return instance
        }else{
          Globals.auth.authFailure()
        }      
      }else Globals.auth.deviceFailure()
    }
    public static async post<Data , Response>(url:string , data:Data , transform?:AxiosResponseTransformer | AxiosResponseTransformer[] | undefined){
      const token = await Globals.auth.getToken()
      const device_key = Cookies.get('dev_tkn')
      if(device_key){
        if(token){
          const instance = await AxiosRequest.getInstance(token,device_key,transform).post<IResponse<Response>>(url,data)
          if(instance.data.messege == 'A0006') Globals.auth.deviceFailure()
            else return instance
        }
        else{
          Globals.auth.authFailure()
        }
      }else Globals.auth.deviceFailure()
    }
    public static async filesPost<Data , Response>(url:string , data:Data , transform?:AxiosResponseTransformer | AxiosResponseTransformer[] | undefined){
      const token = await Globals.auth.getToken()
      const device_key = Cookies.get('dev_tkn')
      if(device_key){
        if(token){
          const instance = await AxiosRequest.getInstance(token,device_key,transform).post<IResponse<Response>>(url,data,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
          )
          if(instance.data.messege == 'A0006') Globals.auth.deviceFailure()
            else return instance
        }
        else{
          Globals.auth.authFailure()
        }
      }else Globals.auth.deviceFailure()
    }

    public static async statusPost<Data>(url:string , data:Data , transform?:AxiosResponseTransformer | AxiosResponseTransformer[] | undefined){
      const token = await Globals.auth.getToken()
      const device_key = Cookies.get('dev_tkn')
      if(device_key){
        if(token){
          const instance = await AxiosRequest.getInstance(token,device_key,transform).post<IResponse<null>>(url,data)
          if(instance.data.messege == 'A0006') Globals.auth.deviceFailure()
            else return instance
        }
        else{
          Globals.auth.authFailure()
        }
      }else Globals.auth.deviceFailure()
    }
    public static async statusFilesPost<Data>(url:string , data:Data , transform?:AxiosResponseTransformer | AxiosResponseTransformer[] | undefined){
      const token = await Globals.auth.getToken()
      const device_key = Cookies.get('dev_tkn')
      if(device_key){
        if(token){
          const instance = await AxiosRequest.getInstance(token,device_key,transform).post<IResponse<null>>(url,data,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
          )
          if(instance.data.messege == 'A0006') Globals.auth.deviceFailure()
          else return instance
        }
        else{
          Globals.auth.authFailure()
        }
      }else Globals.auth.deviceFailure()
    }

    public static async get<Response>(url:string , transform?:AxiosResponseTransformer | AxiosResponseTransformer[] | undefined){
      const token = await Globals.auth.getToken()
      const device_key = Cookies.get('dev_tkn')
      if(device_key){
        if(token){
        const instance = await AxiosRequest.getInstance(token,device_key,transform).get<IResponse<Response>>(url)
        if(instance.data.messege == 'A0006') Globals.auth.deviceFailure()
          else return instance
        }
        else{
          Globals.auth.authFailure()
        }
      }else Globals.auth.deviceFailure()
    }

    public static async postAuth(url:string,token:string){
      const device_key = Cookies.get('dev_tkn')
      if(device_key){
        const instance = await AxiosRequest.getInstance(token,device_key).post<IResponse<ILoginResponseData>>(url)
        if(instance.data.messege == 'A0006') Globals.auth.deviceFailure()
        else return instance
      }else Globals.auth.deviceFailure()
    }
    public static async postlogin(url:string,data:ILoginData){
      const device_key = Cookies.get('dev_tkn')
      if(device_key){
        const instance = await axios.create({baseURL:AxiosRequest.baseUrl,headers:{'x-device-key': device_key}}).post<IResponse<ILoginResponseData>>(url,data)
        if(instance.data.messege == 'A0006') Globals.auth.deviceFailure()
          else return instance
      }else Globals.auth.deviceFailure()
    }
    public static async postActivateDevice(url:string , data:{password:string}){
      return await axios.create({baseURL:AxiosRequest.baseUrl}).post<IResponse<{token:string}>>(url,data)
    }
    public static async postCheckDevice(url:string , data:{token:string}){
      return await axios.create({baseURL:AxiosRequest.baseUrl}).post<IResponse<{token:string}>>(url,data)
    }

}